import { Checkbox } from '../../../_lib/Form2';
import { CheckboxModifier } from '../../../_lib/Form2/elements/Checkbox/Checkbox';
import React from 'react';
import { useSharedFilesSelectedItemsContext } from '../context/SharedFilesSelectedItems';
import { useSonTranslation } from '../../../translation/useSonTranslation';
import { SharedFilesDataRowEntities } from '../SharedFiles.types';

type SharedFilesRowCheckbox = { name: string } & SharedFilesDataRowEntities;

/**
 * Checkbox of a single row.
 * Sets data-entity attributes to identify selected files or directories.
 */
export function SharedFilesRowCheckbox({ name, dataSharedEntityId, dataSharedEntityType }: SharedFilesRowCheckbox) {
  const { toggleSingleRow } = useSharedFilesSelectedItemsContext();
  const { t } = useSonTranslation('SharedFiles');

  return (
    <Checkbox
      labelInvisible
      modifier={CheckboxModifier.SINGLE_CHECKBOX_WITHOUT_TEXT_LABEL}
      label={t('table.checkbox.row.label', { name: name })}
      onChange={toggleSingleRow}
      data-entity-id={dataSharedEntityId}
      data-entity-type={dataSharedEntityType}
    />
  );
}

/**
 * Global checkbox used to check and uncheck all items.
 */
export function SharedFilesGlobalCheckbox() {
  const { toggleAllCheckboxes, globalCheckboxRef } = useSharedFilesSelectedItemsContext();
  const { t } = useSonTranslation('SharedFiles');

  return (
    <Checkbox
      labelInvisible
      modifier={CheckboxModifier.SINGLE_CHECKBOX_WITHOUT_TEXT_LABEL}
      label={t('table.checkbox.global.label')}
      ref={globalCheckboxRef}
      onChange={event => toggleAllCheckboxes(event.target.checked)}
    />
  );
}
